import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { elasticSearchService } from '../services/apiServices';
import Tiles from '../components/Tiles';
import Experts2 from '../components/Experts2';
import { SpinLoader } from '../utilities';
import EmptyAlert from '../components/EmptyAlert';
import { isMobile } from 'react-device-detect';
import MetaDecorators from '../components/MetaDecorators';

function SearchLanding() {
  const { domainDetails } = useSelector((state) => state.listings);
  const [searchResults, setSearchResults] = useState({});
  const [noResults, setNoResults] = useState(false);
  const [activeTabs, setActiveTabs] = useState(1);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(false);

  const { query } = useParams();

  useEffect(() => {
    if (domainDetails && domainDetails.id && query) {
      fetchElasticSearch(query);
    }
  }, [query, domainDetails]);

  const fetchElasticSearch = (text) => {
    setLoading(true);
    setNoResults(false);
    setSearchResults({});
    setActiveTabs(1);
    const payload = {
      text: text,
      organizations: [domainDetails.id],
    };
    elasticSearchService(payload)
      .then((response) => {
        if (response.experts && response.experts.length === 0 && response.videos && response.videos.length === 0) {
          setNoResults(true);
        }
        if (response.videos && response.videos.length === 0) {
          setActiveTabs(2);
        } else {
          setNoResults(false);
        }
        setLoading(false);
        setApiError(false);
        setSearchResults(response);
      })
      .catch((error) => {
        setLoading(false);
        setApiError(true);
      });
  };

  return (
    <div id='searchLanding' className='wrapper'>
      <MetaDecorators />
      <h2>
        Showing Results for <span>" {query} "</span>
      </h2>
      {loading ? (
        <div className='loader'>
          <SpinLoader />
        </div>
      ) : noResults || apiError ? (
        <EmptyAlert message={apiError ? 'Something went wrong! Please try again.' : 'No results found... Try searching for something else.'} />
      ) : (
        <div className='tabsWrapper'>
          <ul className='tabsList'>
            {searchResults && searchResults.videos && searchResults.videos.length > 0 && (
              <li className={activeTabs === 1 ? 'activeTabs' : ''} onClick={() => setActiveTabs(1)}>
                Videos<span className='tabsBadge'>{searchResults.videos.length}</span>
              </li>
            )}
            {searchResults && searchResults.experts && searchResults.experts.length > 0 && domainDetails && domainDetails.orgType === 'certifier' && (
              <li className={activeTabs === 2 ? 'activeTabs' : ''} onClick={() => setActiveTabs(2)}>
                Experts<span className='tabsBadge'>{searchResults.experts.length}</span>
              </li>
            )}
          </ul>
          <section className='tabsContent' hidden={activeTabs !== 1}>
            <div className='tilesGrid'>
              {searchResults &&
                searchResults.videos &&
                searchResults.videos.map((items, index) => {
                  return (
                    <Tiles
                      key={index}
                      courseId={items.id}
                      title={items.name}
                      media={window.innerWidth < 769 && items.portraitThumbnail ? items.portraitThumbnail : items.landscapeThumbnail ? items.landscapeThumbnail : items.thumbnail}
                      courseSlug={items.slug}
                      speciality={items.specialities}
                      experts={items.experts ? items.experts : []}
                      platformType={items.type}
                      index={index}
                    />
                  );
                })}
            </div>
          </section>
          <section className='tabsContent' hidden={activeTabs !== 2}>
            <div className='expertsTilesGrid'>
              {searchResults &&
                searchResults.experts &&
                searchResults.experts.map((items, index) => {
                  return <Experts2 key={index} id={items.id} name={items.name} media={items.profilePic} qualification={items.qualification} location={items.location} index={index} />;
                })}
            </div>
          </section>
        </div>
      )}
    </div>
  );
}

export default SearchLanding;
